import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

const subscribe = new Restful(project, 'mail/subscribe')
subscribe.openMail = function(data) {
  const url = project + 'open/mail/subscribe'
  return http.get(url, data).then(res => {
    return res
  })
}

subscribe.getState = function(data) {
  const url = project + 'open/mail/subscribe/state'
  return http.get(url, data).then(res => {
    return res
  })
}
export default subscribe
